import { CloseOutlined } from "@mui/icons-material";
import { DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

interface EnhancedDialogTitleProps {
  title: string;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  disableClose?: boolean;
  sx?: SxProps<Theme>;
}

export const EnhancedDialogTitle: React.FC<EnhancedDialogTitleProps> = (props) => {
  const { title, onClose, disableClose, sx } = props;

  return (
    <DialogTitle id={`${title}-dialog-title`} component="div" sx={sx}>
      <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <Typography variant="h4">{title}</Typography>
        <IconButton id={`${title}-dialog-close-button`} onClick={onClose} aria-label={"close"} disabled={disableClose}>
          <CloseOutlined fontSize="medium" />
        </IconButton>
      </Stack>
    </DialogTitle>
  );
};
